import React, { useEffect } from "react";
import "./Footer.css";
import { FaFacebookF } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaYoutube } from "react-icons/fa6";
import { FaLinkedin } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa6";
import { Link } from "react-router-dom";
import "aos/dist/aos.css";
import AOS from "aos";

const Footer = () => {
   useEffect(() => {
      AOS.init({ duration: 1000 });
    }, []);

  return (
    <footer className="footerBlock">
    <div className="container-bg-additional relative clearfix">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-sm-7 mt-ftr">
            <div className="row">
            <div className="col-md-6 col-sm-12 col-xs-12">
              <div className="b-footer-socials">
                <ul>
                  <li className="socials-title font-secondary">ISOLS Brands</li>
                  <li>
                    <Link to="/innovative-solution-technologies">Innovative Solution Technologies</Link>
                  </li>
                  <li>
                    <Link to="/digital-india-leader">Digital India Leader</Link>
                  </li>
                  <li>
                    <Link to="/iidts">Indian Institute of Digital Transformations</Link>
                  </li>
                  <li>
                    <Link to="/thirsty-hunter">Thirsty Hunter</Link>
                  </li>
                </ul>
              </div>
              <div className="b-footer-socials pd30" style={{ paddingTop: "30px" }}>
                <ul>
                  <li className="socials-title font-secondary">About Us</li>
                  <li>
                    <Link to="/about-isolsgroup">Company</Link>
                  </li>
                  <li>
                    <Link to="/clients">Key Clients</Link>
                  </li>
                  <li>
                    <Link to="/award-certifications">Awards &amp; Recognitions</Link>
                  </li>
                  <li>
                    <Link to="/careers">Careers</Link>
                  </li>
                  <li>
                    <Link to="/contact">Contact Us</Link>
                  </li>
                </ul>
              </div>
              <div className="b-footer-socials pd30" style={{ paddingTop: "30px" }}>
        <ul>
          <li className="socials-title font-secondary">Quick Links</li>
          <li>
            <Link to="terms-conditions">
              Terms &amp; Conditions
            </Link>
          </li>
          <li>
            <Link to="/privacy-policy">
              Privacy Policy
            </Link>
          </li>
          <li>
            <Link to="/refund-policy">
              Refund Policy
            </Link>
          </li>
          <li>
            <Link to="/dmca-Policy">DMCA Policy</Link>
          </li>
          <li>
            <Link to="/sitemap">Sitemap</Link>
          </li>
          <li>
            <Link to="https://rzp.io/l/09Ag6Hph" target="_blank" rel="noopener noreferrer">
              Pay Online
            </Link>
          </li>
        </ul>
      </div>
            </div>
            <div className="col-md-6 col-sm-12 col-xs-12">
              <div className="b-footer-socials pd30">
                <ul>
                  <li className="socials-title font-secondary">Solution &amp; Services</li>
                  <li><Link to="/business-technology-solutions">Business Technology</Link></li>
                  <li><Link to="/digital-marketing-solutions">Digital Marketing</Link></li>
                  <li><Link to="/digital-payment-solutions">Digital Payments</Link></li>
                  <li><Link to="/business-process-management">Business Process Management</Link></li>
                  <li><Link to="/cloud-infra-solutions">Cloud Infrastructure</Link></li>
                  <li><Link to="/technology-digital-consulting">Tech Digital Consulting</Link></li>
                </ul>
              </div>
              <div className="b-footer-socials pd30 pt" style={{ paddingTop: "30px" }}>
        <ul>
          <li className="socials-title font-secondary">Important Links</li>
          <li>
            <Link to="/search-engine-optimization">
              Search Engine Optimization
            </Link>
          </li>
          <li>
            <Link to="/social-media-marketing">
              Social Media Marketing
            </Link>
          </li>
          <li>
            <Link to="/online-reputation-management">
              Online Reputation Management
            </Link>
          </li>
          <li>
            <Link to="/pay-per-click">
              Pay Per Click Advertising
            </Link>
          </li>
          <li>
            <Link to="/influencer-marketing">
              Influencer Marketing
            </Link>
          </li>
        </ul>
      </div>

      <div className="b-footer-socials pd30 pt" style={{ paddingTop: "30px" }}>
        <ul>
          <li className="socials-title font-secondary">Industry Solutions</li>
          <li>
            <Link to="/healthcare-medical-solutions">
              Healthcare &amp; Medical Tech &amp; Digital Solutions
            </Link>
          </li>
          <li>
            <Link to="/travel-hospitality-solutions">
              Travel &amp; Hospitality Tech &amp; Digital Solutions
            </Link>
          </li>
          <li>
            <Link to="/publishing">
              Publishing Tech &amp; Digital Solutions
            </Link>
          </li>
        </ul>
      </div>
            </div>
            </div>
          </div>
          <div className="col-xs-12 col-sm-12">
            <div className="b-footer-right-side">
              <div className="b-footer-socials pt-30 pb-30">
                <ul className="list-inline" style={{ width: "50%" }}>
                  <li className="socials-title font-secondary wh1">Connect</li>
                  <li>
                    <a className="icon" href="https://www.facebook.com/isolsgroup/" target="_blank" rel="noopener noreferrer"> <FaFacebookF />
                    </a>
                  </li>
                  <li>
                    <a className="icon" href="https://twitter.com/isolsgroup" target="_blank" rel="noopener noreferrer"><FaXTwitter /></a>
                  </li>
                  <li>
                    <a className="icon" href="https://www.youtube.com/channel/UCwDHmTb0BwdYdYIctrdpWvw" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
                  </li>
                  <li>
                    <a className="icon" href="https://in.linkedin.com/company/isolsgroup" target="_blank" rel="noopener noreferrer"> <FaLinkedin />
                    </a>
                  </li>
                  <li>
                    <a className="icon" href="https://www.instagram.com/isolsgroup/?hl=en" target="_blank" rel="noopener noreferrer"> <FaInstagram />
                    </a>
                  </li>
                </ul>
                <div
      className="list-inline1 iconn"
      style={{ float: "right", marginTop: "-42px", marginRight: "-70px" }}
    >
      <img
        src="/images/cmmi.jpg"
        alt="CMMI Maturity Level 5 Certified"
        loading="lazy"
      />
      &nbsp;
      <img
        src="/images/iso9001.png"
        alt="ISO 9001:2015 Certified Co."
        loading="lazy"
      />
      &nbsp;
      <img
        src="/images/iso2001.png"
        alt="ISO 20000-1:2011 Certified Co."
        loading="lazy"
      />
      <img
        src="/images/iso27.png"
        alt="ISO 27001:2013 Certified Co."
        loading="lazy"
      />
      <img
        src="/images/copyscape.png"
        alt="Copyscape logo"
        style={{ padding: "6px 11px" }}
        width="108"
        height="38"
        loading="lazy"
      />
      <a
        href="https://www.dmca.com/Protection/Status.aspx?ID=fd6835fe-c4e6-4d7d-867c-07e67e15c2c7&amp;refurl=https://www.isolsgroup.com/"
        title="DMCA.com Protection Status"
        className="dmca-badge"
      >
        <img
          src="/images/DMCA_logo-200w.png"
          loading="lazy"
          style={{ borderRadius: "5px", width: "102px" }}
          alt="DMCA.com Protection Status"
        />
      </a>
      <script
        defer
        src="https://images.dmca.com/Badges/DMCABadgeHelper.min.js"
      ></script>
    </div>
                <div className="text-right cp font-primary">Copyrights &copy; 2025 ISOLS Group. All Rights Reserved</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="b-footer-bg-filter customBgColor" data-aos="fade-right"></div>

    </div>
  </footer>
  );
};

export default Footer;
